import { Navigate, useOutletContext } from 'react-router-dom'

import { Box } from '@factorialco/deprecated-design-system'

import { useAsyncData } from 'modules/core/hooks/useAsyncData'
import { useNavigation } from 'modules/core/hooks/useNavigation'

import contractVersions from 'modules/contracts/store/collections/contractVersions'
import Editors from 'modules/enps/components/Editors'
import type Form from 'modules/enps/store/models/Form'
import { ResponsivePage } from 'modules/layout/components/ResponsivePage'

import BasicInfo from './BasicInfo/index'
import DateFrequency from './DateFrequency'

const Configuration = () => {
  const { form } = useOutletContext<{ form: Form }>()

  const canEdit = form && form.policy.can('editEnpsForm')
  const { navigation } = useNavigation()

  const { loading } = useAsyncData(
    () => contractVersions.fetch({ withCachedFetchParams: true }),
    []
  )

  if (!canEdit) return <Navigate to={navigation.engagement.enps.answers.fullPath()} />

  return (
    <ResponsivePage.Body
      loading={loading}
      error={null}
      showHeader={false}
      actions={{
        primary: [],
      }}
    >
      <Box gap="s48">
        <BasicInfo form={form} />
        <DateFrequency form={form} />
        <Editors form={form} contractVersions={contractVersions} />
      </Box>
    </ResponsivePage.Body>
  )
}

export default Configuration
